<template>
  <div class='sc-message--struct' :style="messageColors.received">
   <p v-if="data.title" class="sc-message--struct-title">{{data.title}}</p>
   <p v-if="data.text" class="sc-message--struct-content">{{data.text}}</p>
   <div v-if="data.buttons" class="sc-message--struct-buttons">
     <template v-for="(button, idx) in data.buttons">
       <button v-if="['postback', 'callback'].includes(button.type)"
               class="button"
               :key="`button-${idx}`"
               :style="messageColors.sent"
               @click="$emit('buttonPressed', button)"
       >
         <span class="button-text">{{button.title}}</span>
       </button>
       <a v-if="button.type === 'url'" :href="button.payload" target="_blank" :key="`button-${idx}`" class="button" :style="messageColors.sent" @click="$emit('buttonPressed', button)"><span class="button-text">{{button.title}}</span></a>
       <a v-if="button.type === 'phone'" :href="`tel:${button.payload}`" target="_parent" :key="`button-${idx}`" class="button" :style="messageColors.sent" @click="$emit('buttonPressed', button)"><span class="button-text">{{button.title}}</span></a>
     </template>
   </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
}
</script>
